export default __webpack_public_path__ + "static/How Sleep Boosts Immunity System Against Covid-19-93980c03a51d597563c1ec6b37f30909.jpg";